// // src/layout/AppHeader.jsx
// import { AppBar, Toolbar, Typography, Avatar, Box, Button } from "@mui/material";

// export default function AppHeader({ user, onLogout }) {
//   return (
//     <AppBar
//       position="sticky"
//       elevation={0}
//       sx={{ bgcolor: "#ffffff", borderBottom: "1px solid #e5e7eb" }}
//     >
//       <Toolbar>
//         <Avatar sx={{ bgcolor: "#2f80ed", mr: 1, }}></Avatar>


//         <Box sx={{ flex: 1 }}>
//           <Typography variant="h6" fontWeight={400} color="text.primary">
//            {user?.name || ""}
//           </Typography>
//           <Typography variant="caption" color="text.secondary">
//             {user?.email || user?.phone || ""}
//           </Typography>
//         </Box>

//         <Button size="small" onClick={onLogout}>
//           Logout
//         </Button>
//       </Toolbar>
//     </AppBar>
//   );
// }


// src/Layout/AppHeader.jsx
import {
  AppBar,
  Toolbar,
  Typography,
  Avatar,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import PersonIcon from "@mui/icons-material/Person";

export default function AppHeader({ user, onLogout }) {
  // Avatar initials from name or email
  const initials =
    (user?.name || user?.email || "U")
      .toString()
      .trim()
      .split(/\s+/)
      .map((s) => s[0])
      .slice(0, 2)
      .join("")
      .toUpperCase() || "U";

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: "rgba(255,255,255,0.97)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid #f3f4f6",
        color: "#111827",
        boxShadow: "0 2px 16px rgba(21,128,61,0.07)",
      }}
    >
      <Toolbar
        sx={{
          py: 1,
          px: { xs: 2, sm: 2.5 },
          gap: 1.25,
          maxWidth: 560,
          mx: "auto",
          width: "100%",
          minHeight: "64px !important",
        }}
      >
        {/* LOGO ICON */}
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 12px rgba(21,128,61,0.30)",
            flexShrink: 0,
            mr: 0.5,
          }}
        >
          <PersonIcon sx={{ color: "#009751", fontSize: 30 }} />
        </Box>

        {/* NAME + EMAIL */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: '"Sora", sans-serif',
              fontWeight: 700,
              fontSize: 15,
              color: "#111827",
              lineHeight: 1.25,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {user?.name || "Customer"}
          </Typography>
          {(user?.email || user?.phone) && (
            <Typography
              sx={{
                fontSize: 11.5,
                color: "#6b7280",
                lineHeight: 1.2,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {user?.email || user?.phone}
            </Typography>
          )}
        </Box>

        {/* AVATAR */}
        <Avatar
          sx={{
            width: 36,
            height: 36,
            bgcolor: "#dcfce7",
            color: "#15803d",
            fontFamily: '"Sora", sans-serif',
            fontWeight: 800,
            fontSize: 13,
            border: "1.5px solid #bbf7d0",
          }}
        >
          {initials}
        </Avatar>

        {/* LOGOUT */}
        <Tooltip title="Logout">
          <IconButton
            onClick={onLogout}
            size="small"
            sx={{
              color: "#6b7280",
              bgcolor: "#f3f4f6",
              border: "1px solid #e5e7eb",
              borderRadius: 0,
              width: 34,
              height: 34,
              "&:hover": {
                bgcolor: "#fee2e2",
                color: "#ef4444",
                borderColor: "#fecaca",
              },
              transition: "all 200ms ease",
            }}
          >
            <LogoutRoundedIcon sx={{ fontSize: 17 }} />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
}